import type { Router } from "vue-router";
import { hasAnalyticsConsent as getAnalyticsConsent } from "./useCookieConsent";

let routerTrackingInstalled = false;

function canUseWindow(): boolean {
  return typeof window !== "undefined";
}

function hasAnalyticsConsent(): boolean {
  return canUseWindow() && getAnalyticsConsent();
}

function sendAnalyticsEvent(
  action: string,
  params: Record<string, unknown>,
): void {
  if (!canUseWindow()) {
    return;
  }

  if (!hasAnalyticsConsent() || typeof window.gtag !== "function") {
    return;
  }

  window.gtag("event", action, params);
}

export function useAnalytics() {
  function trackPage(pageLocation: string, pageTitle?: string): void {
    sendAnalyticsEvent("page_view", {
      page_location: pageLocation,
      ...(pageTitle ? { page_title: pageTitle } : {}),
    });
  }

  function trackEvent(
    category: string,
    action: string,
    label?: string | null,
  ): void {
    sendAnalyticsEvent(action, {
      event_category: category,
      ...(label ? { event_label: label } : {}),
    });
  }

  function setupRouterTracking(router: Router): void {
    if (routerTrackingInstalled) {
      return;
    }

    routerTrackingInstalled = true;

    router.afterEach((to) => {
      const routeTitle =
        typeof to.name === "string" && to.name.trim().length > 0
          ? to.name
          : document.title;

      trackPage(window.location.href, routeTitle);
    });
  }

  return {
    setupRouterTracking,
    trackEvent,
    trackPage,
  };
}
